var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionTypeIbImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 109,
    viewBox: "0 0 125 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.9492,
    y: 16.7539,
    width: 83.2247,
    height: 64.9945,
    rx: 2.77093,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2059,
    y: 16.2547,
    width: 82.5512,
    height: 64.321,
    rx: 2.4342,
    stroke: "black",
    strokeWidth: 0.673465,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 35.7764,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 35.7764,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 35.7764,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 35.7764,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 28.6426,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 28.6426,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 28.6426,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 28.6426,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 50.8359,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 50.8359,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 50.8359,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 50.8359,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 43.7021,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 43.7021,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 43.7021,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 43.7021,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 66.6885,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 66.6885,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 66.6885,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 66.6885,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 59.5547,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 59.5547,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 59.5547,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.2988,
    y: 59.5547,
    width: 30.1194,
    height: 2.37785,
    rx: 1.18892,
    fill: "#DAE9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.899 35.588L64.7936 34.4914C64.1376 33.8616 63.3587 33.362 62.5016 33.0212C61.6445 32.6803 60.7259 32.5049 59.798 32.5049C58.8702 32.5049 57.9515 32.6803 57.0945 33.0212C56.2374 33.362 55.4585 33.8616 54.8025 34.4914L49.3896 39.7231C49.2693 39.8387 49.2017 39.9954 49.2017 40.1589C49.2017 40.3223 49.2693 40.479 49.3896 40.5947L51.6902 42.8055C51.8107 42.921 51.9739 42.9859 52.1442 42.9859C52.3145 42.9859 52.4778 42.921 52.5981 42.8055L55.6237 39.9034L63.7844 47.7373C63.9049 47.853 64.0682 47.9178 64.2383 47.9178C64.4086 47.9178 64.572 47.853 64.6923 47.7373L66.3533 46.1453C66.4736 46.0297 66.5412 45.873 66.5412 45.7095C66.5412 45.5461 66.4736 45.3894 66.3533 45.2738L58.1926 37.4375L62.7055 33.1051",
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.899 35.588L64.7936 34.4914C64.1376 33.8616 63.3587 33.362 62.5016 33.0212C61.6445 32.6803 60.7259 32.5049 59.798 32.5049C58.8702 32.5049 57.9515 32.6803 57.0945 33.0212C56.2374 33.362 55.4585 33.8616 54.8025 34.4914L49.3896 39.7231C49.2693 39.8387 49.2017 39.9954 49.2017 40.1589C49.2017 40.3223 49.2693 40.479 49.3896 40.5947L51.6902 42.8055C51.8107 42.921 51.9739 42.9859 52.1442 42.9859C52.3145 42.9859 52.4778 42.921 52.5981 42.8055L55.6237 39.9034L63.7844 47.7373C63.9049 47.853 64.0682 47.9178 64.2383 47.9178C64.4086 47.9178 64.572 47.853 64.6923 47.7373L66.3533 46.1453C66.4736 46.0297 66.5412 45.873 66.5412 45.7095C66.5412 45.5461 66.4736 45.3894 66.3533 45.2738L58.1926 37.4375L62.7055 33.1051",
    stroke: "#E3DFE9",
    strokeWidth: 2.60093,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2018 47.918H38.7981C35.9251 47.918 33.5962 50.2469 33.5962 53.1198V61.7896C33.5962 64.6625 35.9251 66.9915 38.7981 66.9915H49.2018C52.0747 66.9915 54.4037 64.6625 54.4037 61.7896V53.1198C54.4037 50.2469 52.0747 47.918 49.2018 47.918Z",
    stroke: "#9BBAC1",
    strokeWidth: 2.60093,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8666 58.3217L45.7335 54.0784L42.2656 53.2296L45.6973 47.918",
    stroke: "#9BBAC1",
    strokeWidth: 2.60093,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23047 57.8954L76.6078 18.6084L8.23047 57.8954Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.698 34.1227L116.027 31.0205L110.698 34.1227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7275 88.4323L55.0566 85.3301",
    stroke: "#E3DFE9",
    strokeWidth: 16.7314,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.26 77.4591C114.092 77.5459 114.697 78.2917 114.61 79.1234C114.523 79.9551 113.777 80.5598 112.946 80.473C112.114 80.3862 111.509 79.6404 111.596 78.8087C111.683 77.977 112.429 77.3723 113.26 77.4591Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.778901
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6197 94.8955C32.9873 95.0382 33.9818 96.2646 33.839 97.6323C33.6962 98.9999 32.4699 99.9944 31.1022 99.8516C29.7346 99.7088 28.7401 98.4824 28.8829 97.1148C29.0257 95.7471 30.252 94.7527 31.6197 94.8955Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.751 6.89057C61.1187 7.03337 62.1132 8.25973 61.9704 9.62737C61.8276 10.995 60.6012 11.9895 59.2336 11.8467C57.8659 11.7039 56.8714 10.4776 57.0142 9.10991C57.157 7.74226 58.3834 6.74777 59.751 6.89057Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06599 38.6621C2.6942 38.6621 3.20425 39.1722 3.20425 39.8004C3.20425 40.4286 2.6942 40.9386 2.06599 40.9386C1.43779 40.9386 0.927734 40.4286 0.927734 39.8004C0.927734 39.1722 1.43779 38.6621 2.06599 38.6621Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.616 31.1611C123.244 31.1611 123.755 31.6712 123.755 32.2994C123.755 32.9276 123.244 33.4377 122.616 33.4377C121.988 33.4377 121.478 32.9276 121.478 32.2994C121.478 31.6712 121.988 31.1611 122.616 31.1611Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.459 5.86523L104.759 1.48519",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.992 3.05566L106.372 4.35508",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68213 80.4463L7.82137 76.0219",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11279 77.6924L9.5372 78.8316",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.652 100.212L102.543 95.7309",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9321 97.5498L104.413 98.4409",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeIbImg);
export default __webpack_public_path__ + "static/media/question_type_ib_img.fa089759ac17e0e798a202bc474ef3f5.svg";
export { ForwardRef as ReactComponent };